// NATIVE 

// INSTALLED 

// CUSTOM 
import { AxiosAdapter } from "../commons/adapters";
import { QueryPagination } from "../commons/interfaces";
import { buildQuery } from "../commons/utils/helpers";

const http = new AxiosAdapter();



export const getAllPermissionsService = async (query?: QueryPagination) => {
    try {
        return await http.get<any>(`/v1/permissions?${buildQuery(query)}`);
    } catch (error: any) {
        if (error && !error.ok) return error;
        console.log('getAllPermissionsService ', error);
    }
}

export const createPermissionService = async (data: any) => {
    try {
        return await http.post<any>(`/v1/permissions`, data);
    } catch (error: any) {
        if (error && !error.ok) return error;
        console.log('createPermissionService ', error);
    }
}

export const updatePermissionService = async (id: string, data: any) => {
    try {
        return await http.put<any>(`/v1/permissions/${id}`, data);
    } catch (error: any) {
        if (error && !error.ok) return error;
        console.log('updatePermissionService ', error);
    }
}

export const getPermissionDetailService = async (id: string) => {
    try {
        return await http.get<any>(`/v1/permissions/${id}`);
    } catch (error: any) {
        if (error && !error.ok) return error;
        console.log('getPermissionDetailService ', error);
    }
}

export const deletePermissionService = async (id: string, query?: QueryPagination) => {
    try {
        return await http.delete<any>(`/v1/permissions/${id}?${buildQuery(query)}`);
    } catch (error: any) {
        if (error && !error.ok) return error;
        console.log('deletePermissionService ', error);
    }
}

export const restorePermissionService = async (id: string, query?: QueryPagination) => {
    try {
        return await http.patchTable<any>(`/v1/permissions/${id}/restore?${buildQuery(query)}`);
    } catch (error: any) {
        if (error && !error.ok) return error;
        console.log('restorePermissionService ', error);
    }
}
